import { jsPDF } from 'jspdf';

// Fjalori rri në një vend të vetëm. Këtu jetonte kopja e dytë e tij, dhe një e
// treta — e pavlerë — brenda faqes së raportit; tri kopje do të thonë tri të
// vërteta sapo dikush shton një nivel.
import { SEVERITY_LEVELS, SEVERITY_META } from '../config/warnings';

const SEV_PDF = Object.fromEntries(
  SEVERITY_LEVELS.map((s) => [s, {
    rgb:    SEVERITY_META[s].rgb,
    light:  SEVERITY_META[s].light,
    label:  SEVERITY_META[s].label,
    border: SEVERITY_META[s].pdfBorder,
  }])
);

export { SEVERITY_LEVELS, SEV_PDF };

function buildWarningPdf(r) {
  const doc  = new jsPDF('p', 'mm', 'a4');
  const W    = 210;
  const M    = 20;
  const sev  = SEV_PDF[r.Severity] || SEV_PDF['Kujtesë'];
  const name = `${r.FirstName || ''} ${r.LastName || ''}`.trim() || '-';
  const date = r.CreatedAt ? new Date(r.CreatedAt).toLocaleDateString('sq-AL') : '-';

  // ── Header banner ──────────────────────────────────────────────────────────
  doc.setFillColor(...sev.rgb);
  doc.rect(0, 0, W, 32, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20); doc.setFont(undefined, 'bold');
  doc.text(sev.label, M, 14);
  doc.setFontSize(9);  doc.setFont(undefined, 'normal');
  doc.text('DOKUMENT ZYRTAR HR', M, 21);
  doc.text(`Data: ${date}`, W - M, 14, { align: 'right' });
  doc.text(`Ref: ${r.Id || '-'}`, W - M, 21, { align: 'right' });

  // ── Employee card ──────────────────────────────────────────────────────────
  doc.setTextColor(0, 0, 0);
  let y = 42;
  doc.setFillColor(...sev.light);
  doc.setDrawColor(...sev.border);
  doc.roundedRect(M, y, W - M * 2, 26, 2, 2, 'FD');

  doc.setFontSize(8); doc.setFont(undefined, 'bold');
  doc.setTextColor(100, 116, 139);
  doc.text('PUNËTORI', M + 4, y + 7);
  doc.setFontSize(13); doc.setFont(undefined, 'bold');
  doc.setTextColor(15, 23, 42);
  doc.text(name, M + 4, y + 16);
  if (r.Position || r.DepartmentName) {
    doc.setFontSize(9); doc.setFont(undefined, 'normal');
    doc.setTextColor(100, 116, 139);
    doc.text([r.Position, r.DepartmentName].filter(d => d && d !== '—').join('  ·  '), M + 4, y + 23);
  }
  if (r.Email) {
    doc.setFontSize(8); doc.setFont(undefined, 'normal');
    doc.setTextColor(100, 116, 139);
    doc.text(r.Email, W - M - 4, y + 7, { align: 'right' });
  }

  y += 34;

  // ── Subject + severity row ─────────────────────────────────────────────────
  doc.setFontSize(8); doc.setFont(undefined, 'bold'); doc.setTextColor(100, 116, 139);
  doc.text('SUBJEKTI', M, y);
  doc.text('NIVELI', W / 2 + 4, y);
  y += 5;
  doc.setFontSize(12); doc.setFont(undefined, 'bold'); doc.setTextColor(15, 23, 42);
  doc.text(r.Subject || '-', M, y);
  doc.setFontSize(11);
  doc.setTextColor(...sev.rgb);
  doc.text(r.Severity || '-', W / 2 + 4, y);
  y += 4;
  doc.setDrawColor(226, 232, 240); doc.setTextColor(0, 0, 0);
  doc.line(M, y, W - M, y);
  y += 8;

  // ── Description ───────────────────────────────────────────────────────────
  doc.setFontSize(8); doc.setFont(undefined, 'bold'); doc.setTextColor(100, 116, 139);
  doc.text('PËRSHKRIMI I VËREJTJES', M, y);
  y += 6;
  doc.setFontSize(10); doc.setFont(undefined, 'normal'); doc.setTextColor(30, 41, 59);
  const descLines = doc.splitTextToSize(r.Description || '-', W - M * 2);
  doc.text(descLines, M, y);
  y += descLines.length * 5 + 4;
  doc.setDrawColor(226, 232, 240);
  doc.line(M, y, W - M, y);
  y += 10;

  // ── Issued by ─────────────────────────────────────────────────────────────
  if (r.IssuedBy) {
    doc.setFontSize(8); doc.setFont(undefined, 'bold'); doc.setTextColor(100, 116, 139);
    doc.text('LËSHUAR NGA', M, y);
    y += 5;
    doc.setFontSize(10); doc.setFont(undefined, 'normal'); doc.setTextColor(15, 23, 42);
    doc.text(r.IssuedBy, M, y);
  }

  // ── Signature lines ────────────────────────────────────────────────────────
  const sigY = 245;
  doc.setDrawColor(15, 23, 42);
  doc.line(M, sigY, M + 60, sigY);
  doc.line(W / 2 + 4, sigY, W / 2 + 64, sigY);
  doc.setFontSize(8); doc.setFont(undefined, 'normal'); doc.setTextColor(100, 116, 139);
  doc.text('Nënshkrimi i Punëtorit', M, sigY + 5);
  doc.text('Nënshkrimi i Menaxherit / HR', W / 2 + 4, sigY + 5);

  // ── Footer ─────────────────────────────────────────────────────────────────
  doc.setFillColor(...sev.rgb);
  doc.rect(0, 282, W, 15, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(7); doc.setFont(undefined, 'normal');
  doc.text('Ky dokument është konfidencial dhe gjenerohet automatikisht nga sistemi HR.', W / 2, 288, { align: 'center' });
  doc.text(`Gjeneruar: ${new Date().toLocaleString('sq-AL')}`, W / 2, 293, { align: 'center' });

  return doc;
}

export function downloadWarningPdf(r) {
  const doc  = buildWarningPdf(r);
  const name = `${r.FirstName || ''} ${r.LastName || ''}`.trim().toLowerCase().replace(/\s+/g, '-');
  const date = r.CreatedAt ? new Date(r.CreatedAt).toLocaleDateString('sq-AL').replace(/\//g, '-') : 'date';
  doc.save(`verejtje-${name}-${date}.pdf`);
}

export function getWarningPdfBase64(r) {
  const doc = buildWarningPdf(r);
  const ab  = doc.output('arraybuffer');
  const bytes = new Uint8Array(ab);
  let binary  = '';
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

export function getWarningPdfFilename(r) {
  const name = `${r.FirstName || ''} ${r.LastName || ''}`.trim().toLowerCase().replace(/\s+/g, '-') || 'punëtori';
  const date = r.CreatedAt ? new Date(r.CreatedAt).toLocaleDateString('sq-AL').replace(/\//g, '-') : 'date';
  return `verejtje-${name}-${date}.pdf`;
}
